<script setup lang="ts">
import {onMounted, ref} from "vue";
import FeaturedYachtComponent from "@/components/YachtComponent/FeaturedYachtComponent.vue";
import CustomButton from "@/components/Button/Button.vue";
import {useRoute, useRouter} from 'vue-router';
import {useYachtStore} from "@/stores/yachtStore";
import {useSearchStore} from "@/stores/searchStore";
import {VueSpinner} from "vue3-spinners";
import CharterYachtComponent from "@/components/YachtComponent/CharterYachtComponent.vue";

const router = useRouter();
const route = useRoute();

const yachtStore = useYachtStore();
const searchStore = useSearchStore();


onMounted(() => {
  searchStore.getAllYachts();
});



</script>

<template>
  <div class="container flex flex-col gap-17 place-content-center items-center pt-24 overflow-x-hidden">
    <div class="responsive-title-1 text-primary-darkBlue font-thin">Featured Yachts</div>
    <div v-if="searchStore.loading" class="grid place-content-center mt-10">
      <VueSpinner size="30" color="#beA5aa" />
    </div>

    <div v-else class="container mx-auto place-items-center">
      <div class="grid grid-cols-1 gap-15 mx-auto">
        <div
            v-for="(yacht, index) in searchStore.yachts.slice(0, 3)"
            :key="`${yacht.id}`"
        >
          <FeaturedYachtComponent
              :yacht="yacht"
              :index="index"
              @on-view-details-click="yachtStore.viewYachtDetails(yacht.slug)"
              @on-enquire-yacht-click="(slug) => {router.push({ path: `/yachts/${slug}`, query: { ...route.query, scrollToForm: 'true' }})}"
          />
        </div>
      </div>
    </div>

    <CustomButton v-if="!searchStore.loading"
        type="gradient"
        :outlined="true"
        size="medium"
        :shadow="false"
        class="py-2 px-4"
        @click="router.push('/yachts')"
    >
      SEE ALL YACHTS
    </CustomButton>

  </div>
</template>


<style scoped>

</style>
